const styles = theme => {
    return {
        paperRoot: {
            marginTop: '16px',
            marginLeft: '1rem',
            marginRight: '1rem',
            overflowY: 'auto',
            height: 'auto',
            marginBottom: '2rem',
        },
        root: {
            display: "grid",
            gridTemplateColumns: "67% 33%"
        },
        spinner: {
            position: 'absolute',
            background: 'rgba(255,255,255,.4)',
            width: '100%',
            height: '100%',
            zIndex: '9999',
            top: 0,
            left: 0,
        },
        spinnerImage: {
            top: 'calc(50% - 32.5px)',
            left: 'calc(50% - 65px)',
            position: 'absolute',
            width: '130px',
            userSelect: 'none',
            zIndex: 99999,
        },
        assignForm: {
            alignItems: 'flex-start',
            paddingBottom: "1.5%",
        },
        paper: {
            padding: '0px',
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
        box: {
            display: "grid",
            gridTemplateColumns: "1fr 1.5fr 1fr 1fr 1fr 1fr",
            gridTemplateRows: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
            gridColumnGap: "7px",
            gridRowGap: "7px",
            justifyItems: "stretch",
            alignItems: "stretch",
            height: "100%"
        },
        main: {
            display: 'flex',
            flexDirection: 'row'
        },
        TableHeadTop: {
            border: '1px solid rgba(224, 224, 224, 1)',
            fontSize: '1.2em !important',
            fontWeight: '500 !important',
            textAlign: 'center',
            width: '50%',
            borderRadius: '2px',
            height: '10px'
        },
        primaryButton: {
            background: '#6cca98',
            color: '#fff',
            '&:hover': {
                background: '#6cca98',
                color: '#fff',
            },
            '&:disabled': {
                color: 'rgba(0, 0, 0, 0.38)',
                cursor: 'not-allowed',
                background: '#E4E5E8',
            },
        },
        prescriptionContainer: {
            width: '100%',
            marginTop: '5px',
            float: 'left',
            fontSize: '10px',
            padding: '5px 0px',
            lineHeight: '15px'
        },
        qrcodeContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            float: 'left',
        },
        boxcontainer: {
            width: '100%',
            float:'left',
            display:'flex',
            alignItems:'center'
        },
        boxLogo: {
            float:'left',
            height:'40px',
            width:'40%',
            borderRadius:'5px',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            padding:"4px",
        },
        spacer: {
            width:'5%'
        },
        boxLogoDesc: {
            float:'left',
            color:'#000',
            fontSize:'10px',
            display:'inline-flex',
            width:'65%',
        },
        deliveryContainer: {
            width:'100%',
            marginTop:'5%',
            borderBottom:'1px solid #000',
            float:'left',
            fontSize:'10px',
            padding:'5px 0px',
        },
    }
}

export default styles;


// WEBPACK FOOTER //
// ./src/components/retail-orders/index.styles.js